import { Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import spessertsLogo from "@/assets/spesserts-logo.webp";

const WoodStainingSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Logo */}
          <div className="flex flex-col items-center lg:items-start gap-8">
            <img
              src={spessertsLogo}
              alt="Spessert's Outdoor Restoration - Veteran Owned"
              width={256}
              height={80}
              loading="lazy"
              className="w-64 h-auto"
            />
            {/* CSS gradient placeholder instead of external Unsplash image */}
            <div className="rounded-xl shadow-xl w-full max-w-md aspect-[3/2] bg-gradient-to-br from-amber-700 via-amber-600 to-orange-800 flex items-center justify-center">
              <span className="text-white/80 text-lg font-heading font-bold text-center px-6">Professional Deck & Fence Staining</span>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-secondary mb-4">
              NEED WOOD STAINED?{" "}
              <span className="text-primary">WE KNOW A GUY!</span>
            </h2>
            <h3 className="text-xl font-semibold text-muted-foreground mb-6">
              Professional Fence & Deck Staining
            </h3>
            <p className="text-foreground mb-6 leading-relaxed">
              When it comes to choosing a fence and deck staining service, Spessert's 
              Outdoor Restoration is the way to go! 🌳🏡 We have a reputation for 
              delivering top-notch results that will make your outdoor spaces look 
              brand new. Our team of experts are skilled in the craft of staining 
              and know how to bring out the natural beauty of your wood.
            </p>

            <div className="flex flex-wrap gap-4">
              <a href="mailto:Spessertsoutdoorrestoration@gmail.com">
                <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90">
                  <Mail className="w-4 h-4 mr-2" />
                  Email Spessert's
                </Button>
              </a>
              <a href="tel:+13045824299">
                <Button variant="outline" className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground">
                  <Phone className="w-4 h-4 mr-2" />
                  Call (304) 582-4299
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WoodStainingSection;